import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag, Input, Typography, Select, Empty, Card, Badge, Tooltip, Button } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { LoadingContext } from '../../composants/loadingContext';
import { useTitle } from '../../configurations/utils/Utils';
import axiosInstance from '../../configurations/axiosInstance/AxiosInstance';
import { useSelector } from 'react-redux';
import { formatTitle, getName } from '../../composants/utils/utils';
import Loader from '../../composants/loader/Loader';
import {
    faUserCircle,
    faClose,
    faL,
    faSearch,
    faFilter,
    faClock,
    faGraduationCap,
    faBookOpen,
    faStar,
    faCalendarAlt,
    faDownload,
    faMedal,
    faUsers,
    faAward,
    faChartLine
} from '@fortawesome/free-solid-svg-icons';
import { ColorsContext } from '../../configurations/context/colorContext';

const { Title, Text } = Typography;
const CoursesList = () => {
    const params = useParams();
    const [courses, setCourses] = useState([]);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedLevel, setSelectedLevel] = useState('all');
    const { accessToken } = useSelector(state => state.authUser);
    const { loading, setLoading } = useContext(LoadingContext);
    const { colors, setColors } = useContext(ColorsContext);
    useTitle("Formations Disponibles");

    const findAllFormation = () => {
        setLoading(true);
        const endpoint = params.id
            ? `public/api/learn/formations/published`
            : `public/api/learn/formations/published`;

        axiosInstance(accessToken).get(endpoint).then(
            (response) => {
                setCourses([]);
                if (response.data && response.data.length > 0) {
                    setCourses(response.data);
                    setFilteredCourses(response.data);
                }
                setLoading(false);
            }
        ).catch((error) => {
            setLoading(false);
        });
    }

    // Get level label in French
    const getLevelLabel = (niveau) => {
        const levels = {
            BEGINNER: 'Débutant',
            INTERMEDIATE: 'Intermédiaire',
            ADVANCED: 'Avancé',
            EXPERT: 'Expert'
        };
        return levels[niveau] || niveau;
    };

    // Get level color
    const getLevelColor = (niveau) => {
        const colors = {
            BEGINNER: 'green',
            INTERMEDIATE: 'blue',
            ADVANCED: 'orange',
            EXPERT: 'red'
        };
        return colors[niveau] || 'default';
    };

    // Get status label
    const getStatusLabel = (status) => {
        const statuses = {
            DRAFT: 'Brouillon',
            PUBLISHED: 'Publié',
            ARCHIVED: 'Archivé'
        };
        return statuses[status] || status;
    };

    // Filter courses based on search, category, and level
    useEffect(() => {
        let filtered = courses;

        // Filter by search term
        if (searchTerm) {
            filtered = filtered.filter(course =>
                course.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (course.description && course.description.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (course.categories?.description && course.categories.description.toLowerCase().includes(searchTerm.toLowerCase()))
            );
        }

        // Filter by category
        if (selectedCategory !== 'all') {
            filtered = filtered.filter(course =>
                course.categories?.description === selectedCategory
            );
        }

        // Filter by level
        if (selectedLevel !== 'all') {
            filtered = filtered.filter(course =>
                course.niveau === selectedLevel
            );
        }

        setFilteredCourses(filtered);
    }, [searchTerm, selectedCategory, selectedLevel, courses]);

    // Get unique categories
    const getCategories = () => {
        const categories = courses
            .map(course => course.categories?.description)
            .filter(category => category !== null && category !== undefined && category !== '');
        return ['all', ...new Set(categories)];
    };

    // Get unique levels
    const getLevels = () => {
        const levels = courses
            .map(course => course.niveau)
            .filter(level => level !== null && level !== undefined);
        return ['all', ...new Set(levels)];
    };

    useEffect(() => {
        findAllFormation();
    }, [params.id]);

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
            {loading && <Loader />}

            {/* Hero Section */}
            <div className="bg-gradient-to-r from-green-500 to-blue-500 text-white py-16 px-4">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-8">
                        <h1 className="text-4xl md:text-5xl font-bold mb-4">
                            Catalogue de Formations
                        </h1>
                        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
                            Explorez notre bibliothèque de formations et développez vos compétences
                        </p>
                    </div>

                    {/* Search and Filter Section */}
                    {/* <div className="max-w-5xl mx-auto mt-8">
                        <div className="bg-white rounded-2xl shadow-2xl p-6">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div className="md:col-span-3">
                                    <Input
                                        size="large"
                                        placeholder="Rechercher par titre, description ou catégorie..."
                                        prefix={<FontAwesomeIcon icon={faSearch} className="text-gray-400 mr-2" />}
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="rounded-lg"
                                        allowClear
                                    />
                                </div>

                                <div className="md:col-span-1">
                                    <Select
                                        size="large"
                                        value={selectedCategory}
                                        onChange={setSelectedCategory}
                                        className="w-full"
                                        placeholder="Toutes les catégories"
                                        suffixIcon={<FontAwesomeIcon icon={faFilter} className="text-gray-400" />}
                                    >
                                        {getCategories().filter(cat => cat !== null && cat !== undefined).map(cat => (
                                            <Select.Option key={cat || 'all'} value={cat}>
                                                {cat === 'all' ? '📚 Toutes les catégories' : cat}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>

                                <div className="md:col-span-1">
                                    <Select
                                        size="large"
                                        value={selectedLevel}
                                        onChange={setSelectedLevel}
                                        className="w-full"
                                        placeholder="Tous les niveaux"
                                        suffixIcon={<FontAwesomeIcon icon={faChartLine} className="text-gray-400" />}
                                    >
                                        <Select.Option value="all">🎯 Tous les niveaux</Select.Option>
                                        {getLevels().filter(level => level !== 'all').map(level => (
                                            <Select.Option key={level} value={level}>
                                                {getLevelLabel(level)}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>

                                <div className="md:col-span-1 flex items-center justify-center md:justify-start">
                                    <div className="bg-green-50 text-green-700 px-4 py-2 rounded-lg font-semibold">
                                        <FontAwesomeIcon icon={faBookOpen} className="mr-2" />
                                        {filteredCourses.length} résultat{filteredCourses.length > 1 ? 's' : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>

            {/* Courses Grid Section */}
            <div className="max-w-7xl mx-auto px-4 py-12">
                {filteredCourses.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredCourses.map((course) => (
                            <div key={course.id} className="group transform transition-all duration-300 hover:-translate-y-2">
                                <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col">
                                    {/* Image Container */}
                                    <div className="relative aspect-[16/10] overflow-hidden bg-gradient-to-br from-green-400 to-blue-500">
                                        <img
                                            src={course.imageCouverture || "/images/Best-online-course-platforms.png"}
                                            alt={course.titre}
                                            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                                            onError={(e) => {
                                                e.target.src = "/images/Best-online-course-platforms.png";
                                            }}
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

                                        {/* Category Badge */}
                                        <div className="absolute top-4 left-4">
                                            <span className="bg-white/95 backdrop-blur-sm text-gray-900 px-4 py-2 rounded-full text-xs font-bold shadow-lg uppercase tracking-wide">
                                                {course.categories?.description || 'Formation'}
                                            </span>
                                        </div>

                                        {/* Level Badge */}
                                        <div className="absolute top-4 right-4">
                                            <Tag
                                                color={getLevelColor(course.niveau)}
                                                className="font-semibold px-3 py-1 text-sm border-0 shadow-lg"
                                            >
                                                {getLevelLabel(course.niveau)}
                                            </Tag>
                                        </div>

                                        {/* Quiz Badge */}
                                        {course.withFinalQuiz && (
                                            <div className="absolute bottom-4 left-4">
                                                <div className="bg-yellow-400 text-gray-900 px-3 py-1 rounded-full text-xs font-bold shadow-lg flex items-center gap-1">
                                                    <FontAwesomeIcon icon={faAward} className="text-sm" />
                                                    Quiz final
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Content */}
                                    <div className="p-6 flex-1 flex flex-col">
                                        {/* Title */}
                                        <h3
                                            title={course.titre}
                                            className="text-xl font-bold text-gray-900 mb-3 group-hover:text-green-600 transition-colors duration-300 line-clamp-2 min-h-[3.5rem]"
                                        >
                                            {course.titre}
                                        </h3>

                                        {/* Description */}
                                        {course.description && (
                                            <p className="text-gray-600 text-sm mb-4 line-clamp-2 leading-relaxed">
                                                {course.description}
                                            </p>
                                        )}

                                        {/* Stats Grid */}
                                        <div className="grid grid-cols-2 gap-3 mb-6">
                                            <div className="bg-blue-50 rounded-lg p-3 text-center">
                                                <FontAwesomeIcon icon={faBookOpen} className="text-blue-500 text-lg mb-1" />
                                                <div className="text-sm font-bold text-gray-900">{course.nombreModules || 0}</div>
                                                <div className="text-xs text-gray-600">Module{course.nombreModules > 1 ? 's' : ''}</div>
                                            </div>
                                            <div className="bg-green-50 rounded-lg p-3 text-center">
                                                <FontAwesomeIcon icon={faClock} className="text-green-500 text-lg mb-1" />
                                                <div className="text-sm font-bold text-gray-900">{course.dureeEstimee || 0}h</div>
                                                <div className="text-xs text-gray-600">Durée</div>
                                            </div>
                                        </div>

                                        {/* Inscrits */}
                                        {course.nombreInscrits > 0 && (
                                            <div className="flex items-center gap-2 text-gray-500 text-sm mb-4 pb-4 border-b border-gray-100">
                                                <FontAwesomeIcon icon={faUsers} className="text-purple-500" />
                                                <span className="font-medium">{course.nombreInscrits} inscrit{course.nombreInscrits > 1 ? 's' : ''}</span>
                                            </div>
                                        )}

                                        {/* CTA Button */}
                                        <div className="mt-auto">
                                            <Link
                                                to={`/course_plan/${course.id}`}
                                                className="block w-full text-center text-white font-semibold py-3 px-6 rounded-xl bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                                            >
                                                <FontAwesomeIcon icon={faGraduationCap} className="mr-2" />
                                                Découvrir la formation
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-20">
                        <div className="max-w-md mx-auto">
                            <div className="w-32 h-32 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                                <FontAwesomeIcon icon={faBookOpen} className="text-6xl text-gray-400" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-3">Aucune formation trouvée</h3>
                            <p className="text-gray-600 mb-6">
                                {searchTerm || selectedCategory !== 'all' || selectedLevel !== 'all'
                                    ? "Essayez de modifier vos critères de recherche ou filtres"
                                    : "Aucune formation n'est disponible pour le moment"}
                            </p>
                            {(searchTerm || selectedCategory !== 'all' || selectedLevel !== 'all') && (
                                <Button
                                    size="large"
                                    onClick={() => {
                                        setSearchTerm('');
                                        setSelectedCategory('all');
                                        setSelectedLevel('all');
                                    }}
                                    className="bg-gradient-to-r from-green-500 to-blue-500 text-white border-0 hover:from-green-600 hover:to-blue-600"
                                >
                                    Réinitialiser les filtres
                                </Button>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CoursesList;